// /verify-email?token=… — link from the verification mail
// (send_verification_email). Confirms the address with POST /auth/verify-email.
import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { post } from '../../lib/api.js';
import { errorMessage } from '../../lib/errors.js';
import { useLang, useT } from '../../lib/i18n.jsx';
import PublicCard, { Notice } from './PublicCard.jsx';

export default function VerifyEmail() {
  const t = useT();
  const { lang } = useLang();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState(token ? 'busy' : 'missing'); // busy | ok | invalid | error | missing
  const [err, setErr] = useState('');
  const sent = useRef(false);

  useEffect(() => {
    // Tokens are single-use; StrictMode's double effect must not send it twice.
    if (!token || sent.current) return;
    sent.current = true;
    post('/auth/verify-email', { token })
      .then(() => setState('ok'))
      .catch((e) => {
        if (e?.status === 400 || e?.status === 404 || e?.status === 422) setState('invalid');
        else {
          setErr(errorMessage(e, { lang }));
          setState('error');
        }
      });
  }, [token, lang]);

  return (
    <PublicCard title={t('verify.title')}>
      {state === 'busy' && <p className="login-sub">{t('verify.busy')}</p>}
      {state === 'ok' && (
        <>
          <Notice>{t('verify.ok')}</Notice>
          <Link className="btn-primary public-cta" to="/login">{t('public.toLogin')}</Link>
        </>
      )}
      {state === 'invalid' && <Notice tone="error">{t('verify.invalid')}</Notice>}
      {state === 'missing' && <Notice tone="error">{t('public.missingToken')}</Notice>}
      {state === 'error' && <Notice tone="error">{err}</Notice>}
    </PublicCard>
  );
}
